import { frontendURL } from '../../../helper/URLHelper';

const VoiceTeaser = () => import('./Teaser.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/voice'),
      name: 'voice_teaser',
      component: VoiceTeaser,
      meta: {
        title: 'SIDEBAR.VOICE',
        permissions: ['administrator', 'agent', 'supervisor', 'cx_engineer'],
      },
    },
  ],
};
